var actionTypes = require('../constants/action_types');

module.exports = {
  initialize: function() {
    this.__state = {
      /**
       * Maps hash of EventBase to a list of EventBases in store.
       * @type {Object.<string, Array.<EventBase>>}
       */
      baseMap: {},

      /**
       * Array of events that have not been persisted yet.
       * @type {Array.<BehaviorEvent>}
       */
      eventQueue: [],

      /**
       * Tracks last event in store.
       * Store.initialize will update it to the last event, if one exists.
       * @type {BehaviorEvent}
       */
      lastEvent: null,

      /**
       * Records whether the store has already been initialized.
       * @private
       * @type {boolean}
       */
      initialized: false,

      /**
       * Records whether the store has already been cleared.
       * @private
       * @type {boolean}
       */
      cleared: false
    };

    this.on(actionTypes.UPDATE_BEHAVIOR_STORE, this.__updateState);
  },

  getBaseMap: function() {
    return this.__state.baseMap;
  },

  getEventQueue: function() {
    return this.__state.eventQueue;
  },

  getLastEvent: function() {
    return this.__state.lastEvent;
  },

  getCleared: function() {
    return this.__state.cleared;
  },

  getInitialized: function() {
    return this.__state.initialized;
  },

  /**
   *
   * @param {Object} payload
   * @param {string} payload.key
   * @param {*} payload.value
   * @private
   */
  __updateState: function(payload:any) {
    this.__state[payload.key] = payload.value;
  },
};
